var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/esn.calendar.libs/app/components/avatar/resource-avatar/resource-avatar.pug");
module.exports = (req['default'] || req).apply(req, [])